package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Mayotte Flag (16x12dp)
 *
 * - ISO Alpha-2: YT
 * - ISO Alpha-3: MYT
 * - ISO Numeric: 175
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.Mayotte: ImageVector by lazy {
    ImageVector.Builder(
        name = "Mayotte:YT:MYT:175:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(fill = SolidColor(Color(0xFFDFDFDF))) {
                moveTo(5.545f, 10.615f)
                curveTo(5.212f, 10.715f, 4.733f, 10.921f, 4.541f, 11.037f)
                curveTo(4.479f, 11.077f, 4.484f, 11.123f, 4.58f, 11.294f)
                curveTo(4.648f, 11.404f, 4.716f, 11.5f, 4.727f, 11.5f)
                curveTo(4.744f, 11.5f, 4.93f, 11.425f, 5.139f, 11.329f)
                curveTo(5.348f, 11.238f, 5.614f, 11.119f, 5.737f, 11.097f)
                curveTo(5.831f, 11.081f, 5.916f, 11.066f, 5.969f, 11.046f)
                curveTo(5.991f, 11.092f, 5.978f, 11.066f, 6.017f, 11.139f)
                curveTo(6.072f, 11.243f, 6.038f, 11.241f, 6.134f, 11.269f)
                curveTo(6.236f, 11.3f, 6.488f, 11.178f, 6.488f, 11.178f)
                curveTo(6.781f, 11.087f, 6.945f, 11.077f, 8f, 11.077f)
                curveTo(9.055f, 11.077f, 9.219f, 11.087f, 9.512f, 11.183f)
                curveTo(9.512f, 11.183f, 9.748f, 11.255f, 9.779f, 11.263f)
                curveTo(9.809f, 11.272f, 9.825f, 11.279f, 9.857f, 11.272f)
                curveTo(9.886f, 11.266f, 9.916f, 11.226f, 9.929f, 11.202f)
                curveTo(9.929f, 11.202f, 9.994f, 11.063f, 10.011f, 11.014f)
                curveTo(10.067f, 11.038f, 10.17f, 11.07f, 10.268f, 11.097f)
                curveTo(10.387f, 11.133f, 10.652f, 11.238f, 10.861f, 11.329f)
                curveTo(11.07f, 11.425f, 11.256f, 11.5f, 11.273f, 11.5f)
                curveTo(11.284f, 11.5f, 11.352f, 11.404f, 11.42f, 11.294f)
                curveTo(11.555f, 11.057f, 11.566f, 11.077f, 11.075f, 10.851f)
                curveTo(10.421f, 10.549f, 9.766f, 10.413f, 9.704f, 10.559f)
                curveTo(9.693f, 10.587f, 9.683f, 10.603f, 9.668f, 10.639f)
                curveTo(9.602f, 10.625f, 9.43f, 10.589f, 9.258f, 10.564f)
                curveTo(8.728f, 10.479f, 7.272f, 10.479f, 6.742f, 10.564f)
                curveTo(6.569f, 10.589f, 6.453f, 10.631f, 6.356f, 10.655f)
                curveTo(6.301f, 10.557f, 6.312f, 10.596f, 6.301f, 10.568f)
                curveTo(6.256f, 10.468f, 5.957f, 10.484f, 5.545f, 10.615f)
                horizontalLineTo(5.545f)
                close()
            }
            path(fill = SolidColor(Color(0xFF171796))) {
                moveTo(6.025f, 4.397f)
                curveTo(6.013f, 4.56f, 6.047f, 4.676f, 6.137f, 4.764f)
                curveTo(6.176f, 4.806f, 6.21f, 4.856f, 6.21f, 4.856f)
                curveTo(6.21f, 4.856f, 6.165f, 4.906f, 6.127f, 4.944f)
                curveTo(6.038f, 5.032f, 6.002f, 5.146f, 6.002f, 5.266f)
                curveTo(6.002f, 5.39f, 6.038f, 5.476f, 6.135f, 5.588f)
                curveTo(6.135f, 5.588f, 6.216f, 5.629f, 6.214f, 5.68f)
                curveTo(6.212f, 5.731f, 6.127f, 5.782f, 6.127f, 5.782f)
                curveTo(5.953f, 5.986f, 5.958f, 6.22f, 6.14f, 6.414f)
                lineTo(6.218f, 6.5f)
                horizontalLineTo(8.003f)
                horizontalLineTo(9.786f)
                lineTo(9.873f, 6.402f)
                curveTo(10.042f, 6.212f, 10.042f, 6.006f, 9.875f, 5.788f)
                curveTo(9.875f, 5.788f, 9.791f, 5.728f, 9.79f, 5.678f)
                curveTo(9.789f, 5.628f, 9.869f, 5.578f, 9.869f, 5.578f)
                curveTo(10.044f, 5.358f, 10.04f, 5.156f, 9.86f, 4.944f)
                curveTo(9.779f, 4.85f, 9.777f, 4.832f, 9.841f, 4.788f)
                curveTo(9.945f, 4.714f, 10.01f, 4.464f, 9.962f, 4.313f)
                curveTo(9.892f, 4.085f, 9.591f, 3.933f, 9.407f, 4.033f)
                curveTo(9.373f, 4.051f, 9.305f, 4.101f, 9.254f, 4.143f)
                curveTo(9.202f, 4.187f, 9.155f, 4.221f, 9.146f, 4.221f)
                curveTo(9.138f, 4.221f, 9.093f, 4.185f, 9.045f, 4.141f)
                curveTo(8.861f, 3.975f, 8.64f, 3.955f, 8.456f, 4.143f)
                curveTo(8.456f, 4.143f, 8.43f, 4.243f, 8.391f, 4.247f)
                curveTo(8.353f, 4.25f, 8.299f, 4.157f, 8.299f, 4.157f)
                curveTo(8.111f, 3.971f, 7.876f, 3.979f, 7.685f, 4.175f)
                curveTo(7.685f, 4.175f, 7.658f, 4.256f, 7.615f, 4.247f)
                curveTo(7.571f, 4.237f, 7.536f, 4.141f, 7.536f, 4.141f)
                curveTo(7.424f, 4.033f, 7.353f, 4.035f, 7.224f, 4.033f)
                curveTo(7.15f, 4.031f, 7.016f, 4.049f, 6.935f, 4.11f)
                curveTo(6.853f, 4.171f, 6.868f, 4.243f, 6.849f, 4.239f)
                curveTo(6.802f, 4.226f, 6.75f, 4.151f, 6.75f, 4.151f)
                curveTo(6.569f, 3.987f, 6.423f, 3.959f, 6.246f, 4.057f)
                curveTo(6.108f, 4.133f, 6.036f, 4.245f, 6.025f, 4.397f)
                close()
            }
            path(fill = SolidColor(Color(0xFFD42E12))) {
                moveTo(6.142f, 7.246f)
                curveTo(6.142f, 7.246f, 6.215f, 7.281f, 6.213f, 7.327f)
                curveTo(6.21f, 7.372f, 6.133f, 7.417f, 6.133f, 7.417f)
                curveTo(6.089f, 7.466f, 6.042f, 7.537f, 6.027f, 7.573f)
                curveTo(5.966f, 7.724f, 6.012f, 7.927f, 6.131f, 8.043f)
                curveTo(6.203f, 8.116f, 6.205f, 8.145f, 6.137f, 8.232f)
                curveTo(6.106f, 8.269f, 6.07f, 8.323f, 6.057f, 8.35f)
                curveTo(5.915f, 8.63f, 6.127f, 8.98f, 6.442f, 8.98f)
                curveTo(6.567f, 8.98f, 6.662f, 8.939f, 6.747f, 8.844f)
                curveTo(6.815f, 8.769f, 6.851f, 8.767f, 6.912f, 8.834f)
                curveTo(7.001f, 8.937f, 7.119f, 9f, 7.217f, 9f)
                curveTo(7.333f, 9f, 7.405f, 8.962f, 7.522f, 8.846f)
                curveTo(7.522f, 8.846f, 7.569f, 8.755f, 7.611f, 8.756f)
                curveTo(7.654f, 8.756f, 7.693f, 8.848f, 7.693f, 8.848f)
                curveTo(7.869f, 9.045f, 8.047f, 9.051f, 8.284f, 8.864f)
                curveTo(8.284f, 8.864f, 8.336f, 8.788f, 8.381f, 8.789f)
                curveTo(8.426f, 8.79f, 8.464f, 8.868f, 8.464f, 8.868f)
                curveTo(8.569f, 8.962f, 8.646f, 9f, 8.749f, 9f)
                curveTo(8.851f, 9f, 8.927f, 8.958f, 9.046f, 8.836f)
                curveTo(9.046f, 8.836f, 9.108f, 8.744f, 9.145f, 8.738f)
                curveTo(9.182f, 8.732f, 9.221f, 8.809f, 9.221f, 8.809f)
                curveTo(9.367f, 8.945f, 9.446f, 8.988f, 9.552f, 8.988f)
                curveTo(9.662f, 8.988f, 9.74f, 8.95f, 9.85f, 8.848f)
                curveTo(9.952f, 8.752f, 10.007f, 8.639f, 9.994f, 8.547f)
                curveTo(9.981f, 8.447f, 9.894f, 8.264f, 9.829f, 8.201f)
                curveTo(9.829f, 8.201f, 9.765f, 8.195f, 9.774f, 8.145f)
                curveTo(9.784f, 8.096f, 9.859f, 8.045f, 9.859f, 8.045f)
                curveTo(10.045f, 7.819f, 10.047f, 7.644f, 9.863f, 7.419f)
                curveTo(9.863f, 7.419f, 9.786f, 7.375f, 9.787f, 7.325f)
                curveTo(9.788f, 7.275f, 9.867f, 7.224f, 9.867f, 7.224f)
                curveTo(10.045f, 7.006f, 10.043f, 6.803f, 9.863f, 6.604f)
                lineTo(9.767f, 6.5f)
                lineTo(7.992f, 6.502f)
                lineTo(6.218f, 6.504f)
                lineTo(6.139f, 6.596f)
                curveTo(5.953f, 6.811f, 5.955f, 7.029f, 6.142f, 7.246f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE9D315)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.91f, 6.811f)
                curveTo(8.996f, 6.811f, 9.068f, 6.869f, 9.082f, 6.946f)
                lineTo(9.085f, 6.976f)
                verticalLineTo(7.284f)
                lineTo(9.453f, 7.088f)
                curveTo(9.534f, 7.045f, 9.636f, 7.075f, 9.68f, 7.156f)
                curveTo(9.719f, 7.227f, 9.699f, 7.314f, 9.637f, 7.363f)
                lineTo(9.611f, 7.38f)
                lineTo(9.303f, 7.543f)
                lineTo(9.611f, 7.707f)
                lineTo(9.637f, 7.723f)
                curveTo(9.699f, 7.772f, 9.719f, 7.859f, 9.68f, 7.931f)
                curveTo(9.636f, 8.011f, 9.534f, 8.042f, 9.453f, 7.998f)
                lineTo(9.085f, 7.803f)
                verticalLineTo(8.146f)
                curveTo(9.085f, 8.237f, 9.007f, 8.311f, 8.91f, 8.311f)
                curveTo(8.824f, 8.311f, 8.753f, 8.252f, 8.738f, 8.175f)
                lineTo(8.735f, 8.146f)
                verticalLineTo(7.845f)
                lineTo(8.446f, 7.998f)
                curveTo(8.365f, 8.042f, 8.263f, 8.011f, 8.22f, 7.931f)
                curveTo(8.181f, 7.859f, 8.2f, 7.772f, 8.263f, 7.723f)
                lineTo(8.288f, 7.707f)
                lineTo(8.596f, 7.543f)
                lineTo(8.288f, 7.38f)
                lineTo(8.263f, 7.363f)
                curveTo(8.2f, 7.314f, 8.181f, 7.227f, 8.22f, 7.156f)
                curveTo(8.263f, 7.075f, 8.365f, 7.045f, 8.446f, 7.088f)
                lineTo(8.735f, 7.242f)
                verticalLineTo(6.976f)
                curveTo(8.735f, 6.885f, 8.814f, 6.811f, 8.91f, 6.811f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE9D315)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.211f, 6.811f)
                curveTo(7.297f, 6.811f, 7.368f, 6.869f, 7.383f, 6.946f)
                lineTo(7.386f, 6.976f)
                verticalLineTo(7.284f)
                lineTo(7.753f, 7.088f)
                curveTo(7.835f, 7.045f, 7.936f, 7.075f, 7.98f, 7.156f)
                curveTo(8.019f, 7.227f, 7.999f, 7.314f, 7.937f, 7.363f)
                lineTo(7.912f, 7.38f)
                lineTo(7.604f, 7.543f)
                lineTo(7.912f, 7.707f)
                lineTo(7.937f, 7.723f)
                curveTo(7.999f, 7.772f, 8.019f, 7.859f, 7.98f, 7.931f)
                curveTo(7.936f, 8.011f, 7.835f, 8.042f, 7.753f, 7.998f)
                lineTo(7.386f, 7.803f)
                verticalLineTo(8.146f)
                curveTo(7.386f, 8.237f, 7.307f, 8.311f, 7.211f, 8.311f)
                curveTo(7.125f, 8.311f, 7.053f, 8.252f, 7.039f, 8.175f)
                lineTo(7.036f, 8.146f)
                verticalLineTo(7.845f)
                lineTo(6.747f, 7.998f)
                curveTo(6.665f, 8.042f, 6.564f, 8.011f, 6.52f, 7.931f)
                curveTo(6.481f, 7.859f, 6.501f, 7.772f, 6.563f, 7.723f)
                lineTo(6.588f, 7.707f)
                lineTo(6.896f, 7.543f)
                lineTo(6.588f, 7.38f)
                lineTo(6.563f, 7.363f)
                curveTo(6.501f, 7.314f, 6.481f, 7.227f, 6.52f, 7.156f)
                curveTo(6.564f, 7.075f, 6.665f, 7.045f, 6.747f, 7.088f)
                lineTo(7.036f, 7.242f)
                verticalLineTo(6.976f)
                curveTo(7.036f, 6.885f, 7.114f, 6.811f, 7.211f, 6.811f)
                close()
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f
            ) {
                moveTo(5.401f, 6.428f)
                horizontalLineTo(5.501f)
                verticalLineTo(6.428f)
                curveTo(5.501f, 6.429f, 5.501f, 6.444f, 5.501f, 6.473f)
                curveTo(5.445f, 6.471f, 5.403f, 6.429f, 5.401f, 6.428f)
                lineTo(5.401f, 6.428f)
                lineTo(5.401f, 6.428f)
                lineTo(5.401f, 6.429f)
                lineTo(5.401f, 6.43f)
                lineTo(5.401f, 6.434f)
                lineTo(5.401f, 6.452f)
                lineTo(5.402f, 6.521f)
                lineTo(5.402f, 6.771f)
                lineTo(5.402f, 7.57f)
                curveTo(5.403f, 8.178f, 5.404f, 8.864f, 5.406f, 9.176f)
                curveTo(5.402f, 9.245f, 5.422f, 9.3f, 5.463f, 9.345f)
                curveTo(5.48f, 9.364f, 5.5f, 9.38f, 5.516f, 9.393f)
                curveTo(5.525f, 9.399f, 5.532f, 9.405f, 5.539f, 9.41f)
                curveTo(5.548f, 9.417f, 5.557f, 9.423f, 5.568f, 9.432f)
                curveTo(5.618f, 9.471f, 5.699f, 9.501f, 5.788f, 9.523f)
                curveTo(5.881f, 9.548f, 5.999f, 9.569f, 6.134f, 9.585f)
                curveTo(6.403f, 9.617f, 6.745f, 9.629f, 7.108f, 9.6f)
                curveTo(7.257f, 9.602f, 7.365f, 9.631f, 7.446f, 9.67f)
                curveTo(7.529f, 9.71f, 7.59f, 9.763f, 7.642f, 9.82f)
                curveTo(7.668f, 9.848f, 7.692f, 9.877f, 7.716f, 9.906f)
                lineTo(7.718f, 9.908f)
                curveTo(7.74f, 9.936f, 7.765f, 9.966f, 7.789f, 9.992f)
                curveTo(7.84f, 10.045f, 7.91f, 10.1f, 8.009f, 10.1f)
                curveTo(8.109f, 10.1f, 8.178f, 10.045f, 8.228f, 9.99f)
                curveTo(8.253f, 9.963f, 8.277f, 9.933f, 8.299f, 9.904f)
                lineTo(8.3f, 9.903f)
                curveTo(8.322f, 9.874f, 8.344f, 9.846f, 8.369f, 9.818f)
                curveTo(8.418f, 9.761f, 8.475f, 9.709f, 8.552f, 9.669f)
                curveTo(8.63f, 9.63f, 8.733f, 9.601f, 8.877f, 9.6f)
                curveTo(9.286f, 9.606f, 9.636f, 9.596f, 9.899f, 9.572f)
                curveTo(10.031f, 9.559f, 10.143f, 9.543f, 10.232f, 9.523f)
                curveTo(10.314f, 9.504f, 10.392f, 9.478f, 10.442f, 9.435f)
                lineTo(10.446f, 9.433f)
                lineTo(10.458f, 9.422f)
                curveTo(10.468f, 9.414f, 10.481f, 9.401f, 10.495f, 9.386f)
                curveTo(10.521f, 9.36f, 10.562f, 9.313f, 10.58f, 9.259f)
                curveTo(10.597f, 9.21f, 10.601f, 9.166f, 10.601f, 9.134f)
                curveTo(10.601f, 9.118f, 10.601f, 9.105f, 10.599f, 9.095f)
                curveTo(10.599f, 9.092f, 10.599f, 9.09f, 10.599f, 9.087f)
                verticalLineTo(6.428f)
                verticalLineTo(3.5f)
                verticalLineTo(3.4f)
                horizontalLineTo(10.499f)
                horizontalLineTo(8f)
                horizontalLineTo(5.501f)
                horizontalLineTo(5.401f)
                verticalLineTo(3.5f)
                verticalLineTo(6.428f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(7.434f, 4.933f)
                curveTo(7.3f, 5.183f, 7.295f, 5.295f, 7.406f, 5.495f)
                curveTo(7.493f, 5.649f, 7.595f, 5.747f, 7.735f, 5.809f)
                curveTo(8.1f, 5.974f, 8.567f, 5.852f, 8.75f, 5.545f)
                curveTo(8.863f, 5.356f, 8.85f, 5.04f, 8.725f, 4.902f)
                lineTo(8.691f, 4.866f)
                lineTo(8.659f, 4.975f)
                curveTo(8.614f, 5.13f, 8.569f, 5.208f, 8.478f, 5.292f)
                curveTo(8.308f, 5.447f, 8.073f, 5.482f, 7.831f, 5.386f)
                curveTo(7.644f, 5.311f, 7.569f, 5.207f, 7.499f, 4.917f)
                lineTo(7.482f, 4.845f)
                lineTo(7.434f, 4.933f)
                lineTo(7.434f, 4.933f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFF2500)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.022f, 1.886f)
                curveTo(9.022f, 2.252f, 8.786f, 2.52f, 8.454f, 2.52f)
                curveTo(8.122f, 2.52f, 7.888f, 2.252f, 7.888f, 1.886f)
                curveTo(7.888f, 1.518f, 8.122f, 1.252f, 8.454f, 1.252f)
                curveTo(8.786f, 1.252f, 9.022f, 1.518f, 9.022f, 1.886f)
                close()
                moveTo(4.496f, 2.5f)
                verticalLineTo(1.646f)
                lineTo(4.834f, 2.5f)
                horizontalLineTo(4.982f)
                lineTo(5.312f, 1.646f)
                verticalLineTo(2.5f)
                horizontalLineTo(5.512f)
                verticalLineTo(1.272f)
                horizontalLineTo(5.28f)
                lineTo(4.91f, 2.216f)
                lineTo(4.536f, 1.272f)
                horizontalLineTo(4.298f)
                verticalLineTo(2.5f)
                horizontalLineTo(4.496f)
                close()
                moveTo(5.898f, 2.5f)
                lineTo(6.024f, 2.16f)
                horizontalLineTo(6.494f)
                lineTo(6.62f, 2.5f)
                horizontalLineTo(6.832f)
                lineTo(6.36f, 1.272f)
                horizontalLineTo(6.16f)
                lineTo(5.688f, 2.5f)
                horizontalLineTo(5.898f)
                close()
                moveTo(6.258f, 1.526f)
                lineTo(6.09f, 1.98f)
                horizontalLineTo(6.426f)
                lineTo(6.258f, 1.526f)
                close()
                moveTo(7.422f, 2.5f)
                verticalLineTo(2.01f)
                lineTo(7.868f, 1.272f)
                horizontalLineTo(7.648f)
                lineTo(7.324f, 1.822f)
                lineTo(6.998f, 1.272f)
                horizontalLineTo(6.772f)
                lineTo(7.216f, 2.01f)
                verticalLineTo(2.5f)
                horizontalLineTo(7.422f)
                close()
                moveTo(8.454f, 2.334f)
                curveTo(8.238f, 2.334f, 8.098f, 2.146f, 8.098f, 1.886f)
                curveTo(8.098f, 1.626f, 8.238f, 1.438f, 8.454f, 1.438f)
                curveTo(8.67f, 1.438f, 8.812f, 1.626f, 8.812f, 1.886f)
                curveTo(8.812f, 2.146f, 8.67f, 2.334f, 8.454f, 2.334f)
                close()
                moveTo(9.698f, 1.456f)
                verticalLineTo(2.5f)
                horizontalLineTo(9.49f)
                verticalLineTo(1.456f)
                horizontalLineTo(9.082f)
                verticalLineTo(1.272f)
                horizontalLineTo(10.106f)
                verticalLineTo(1.456f)
                horizontalLineTo(9.698f)
                close()
                moveTo(10.842f, 2.5f)
                verticalLineTo(1.456f)
                horizontalLineTo(11.25f)
                verticalLineTo(1.272f)
                horizontalLineTo(10.226f)
                verticalLineTo(1.456f)
                horizontalLineTo(10.634f)
                verticalLineTo(2.5f)
                horizontalLineTo(10.842f)
                close()
                moveTo(12.248f, 2.314f)
                verticalLineTo(2.5f)
                horizontalLineTo(11.446f)
                verticalLineTo(1.272f)
                horizontalLineTo(12.248f)
                verticalLineTo(1.456f)
                horizontalLineTo(11.65f)
                verticalLineTo(1.78f)
                horizontalLineTo(12.192f)
                verticalLineTo(1.962f)
                horizontalLineTo(11.65f)
                verticalLineTo(2.314f)
                horizontalLineTo(12.248f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFDFDFDF)),
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f,
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.888f, 9.4f)
                curveTo(12.888f, 9.4f, 12.718f, 9.065f, 13.148f, 8.9f)
                curveTo(13.578f, 8.735f, 13.788f, 8.95f, 13.978f, 9.15f)
                curveTo(14.167f, 9.351f, 14.146f, 9.955f, 14.146f, 9.955f)
                lineTo(13.678f, 10.703f)
                lineTo(12.243f, 11f)
                lineTo(11.671f, 10.703f)
                lineTo(11f, 9.4f)
                lineTo(11.05f, 8.121f)
                curveTo(11.05f, 8.121f, 11.118f, 7.631f, 11.118f, 7.529f)
                curveTo(11.118f, 7.428f, 11.429f, 6.641f, 11.429f, 6.641f)
                lineTo(11.725f, 6.349f)
                lineTo(12.559f, 5.905f)
                lineTo(12.952f, 5.709f)
                lineTo(13.44f, 5.092f)
                lineTo(13.386f, 4.601f)
                lineTo(12.83f, 5.31f)
                horizontalLineTo(12.359f)
                lineTo(11.869f, 5.515f)
                lineTo(11.671f, 5.702f)
                lineTo(11.429f, 5.709f)
                lineTo(11.335f, 5.515f)
                lineTo(11.598f, 5.092f)
                lineTo(11.996f, 4.692f)
                lineTo(11.813f, 4.353f)
                lineTo(12.084f, 4.23f)
                lineTo(12.032f, 4.043f)
                lineTo(12.332f, 4.23f)
                lineTo(12.559f, 4.043f)
                lineTo(12.602f, 3.872f)
                lineTo(12.084f, 3.594f)
                curveTo(12.084f, 3.594f, 12.591f, 3.381f, 12.83f, 3.403f)
                curveTo(13.069f, 3.426f, 13.294f, 3.707f, 13.294f, 3.707f)
                lineTo(13.978f, 3.594f)
                curveTo(13.978f, 3.594f, 13.795f, 4.043f, 13.854f, 4.043f)
                curveTo(13.913f, 4.043f, 14.284f, 4.043f, 14.284f, 4.043f)
                lineTo(14.146f, 4.601f)
                horizontalLineTo(14.676f)
                lineTo(14.284f, 5.031f)
                lineTo(14.59f, 5.199f)
                lineTo(14.125f, 5.515f)
                lineTo(14.59f, 5.828f)
                lineTo(14.158f, 6.112f)
                lineTo(14.401f, 6.583f)
                lineTo(14.784f, 6.349f)
                lineTo(15f, 6.641f)
                lineTo(14.676f, 7.361f)
                lineTo(14.146f, 7.737f)
                lineTo(13.642f, 7.864f)
                lineTo(13.148f, 7.992f)
                lineTo(12.952f, 8.121f)
                lineTo(12.83f, 7.628f)
                lineTo(11.996f, 8.2f)
                lineTo(11.563f, 9.097f)
                lineTo(11.69f, 9.912f)
                lineTo(11.996f, 10.329f)
                lineTo(12.559f, 10.531f)
                lineTo(13.294f, 10.392f)
                lineTo(13.678f, 9.925f)
                lineTo(13.77f, 9.448f)
                curveTo(13.77f, 9.448f, 13.547f, 9.124f, 13.386f, 9.15f)
                curveTo(13.224f, 9.177f, 12.888f, 9.4f, 12.888f, 9.4f)
                close()
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f
            ) {
                moveTo(12.043f, 6.21f)
                curveTo(12.043f, 6.21f, 12.933f, 6.292f, 13.17f, 6.103f)
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f
            ) {
                moveTo(11.374f, 6.787f)
                curveTo(11.374f, 6.787f, 12.264f, 6.869f, 12.501f, 6.68f)
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f
            ) {
                moveTo(11.225f, 7.316f)
                curveTo(11.225f, 7.316f, 11.705f, 7.397f, 11.752f, 7.23f)
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.375f, 4.75f)
                curveTo(12.306f, 4.75f, 12.25f, 4.694f, 12.25f, 4.625f)
                curveTo(12.25f, 4.556f, 12.306f, 4.5f, 12.375f, 4.5f)
                curveTo(12.444f, 4.5f, 12.5f, 4.556f, 12.5f, 4.625f)
                curveTo(12.5f, 4.694f, 12.444f, 4.75f, 12.375f, 4.75f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFDFDFDF)),
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f,
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.112f, 9.4f)
                curveTo(3.112f, 9.4f, 3.282f, 9.065f, 2.852f, 8.9f)
                curveTo(2.422f, 8.735f, 2.212f, 8.95f, 2.022f, 9.15f)
                curveTo(1.833f, 9.351f, 1.854f, 9.955f, 1.854f, 9.955f)
                lineTo(2.322f, 10.703f)
                lineTo(3.757f, 11f)
                lineTo(4.329f, 10.703f)
                lineTo(5f, 9.4f)
                lineTo(4.95f, 8.121f)
                curveTo(4.95f, 8.121f, 4.882f, 7.631f, 4.882f, 7.529f)
                curveTo(4.882f, 7.428f, 4.57f, 6.641f, 4.57f, 6.641f)
                lineTo(4.275f, 6.349f)
                lineTo(3.441f, 5.905f)
                lineTo(3.048f, 5.709f)
                lineTo(2.56f, 5.092f)
                lineTo(2.614f, 4.601f)
                lineTo(3.17f, 5.31f)
                horizontalLineTo(3.641f)
                lineTo(4.131f, 5.515f)
                lineTo(4.329f, 5.702f)
                lineTo(4.57f, 5.709f)
                lineTo(4.665f, 5.515f)
                lineTo(4.402f, 5.092f)
                lineTo(4.004f, 4.692f)
                lineTo(4.187f, 4.353f)
                lineTo(3.916f, 4.23f)
                lineTo(3.968f, 4.043f)
                lineTo(3.668f, 4.23f)
                lineTo(3.441f, 4.043f)
                lineTo(3.398f, 3.872f)
                lineTo(3.916f, 3.594f)
                curveTo(3.916f, 3.594f, 3.409f, 3.381f, 3.17f, 3.403f)
                curveTo(2.931f, 3.426f, 2.706f, 3.707f, 2.706f, 3.707f)
                lineTo(2.022f, 3.594f)
                curveTo(2.022f, 3.594f, 2.205f, 4.043f, 2.146f, 4.043f)
                curveTo(2.087f, 4.043f, 1.716f, 4.043f, 1.716f, 4.043f)
                lineTo(1.854f, 4.601f)
                horizontalLineTo(1.324f)
                lineTo(1.716f, 5.031f)
                lineTo(1.41f, 5.199f)
                lineTo(1.875f, 5.515f)
                lineTo(1.41f, 5.828f)
                lineTo(1.842f, 6.112f)
                lineTo(1.599f, 6.583f)
                lineTo(1.216f, 6.349f)
                lineTo(1f, 6.641f)
                lineTo(1.324f, 7.361f)
                lineTo(1.854f, 7.737f)
                lineTo(2.358f, 7.864f)
                lineTo(2.852f, 7.992f)
                lineTo(3.048f, 8.121f)
                lineTo(3.17f, 7.628f)
                lineTo(4.004f, 8.2f)
                lineTo(4.437f, 9.097f)
                lineTo(4.31f, 9.912f)
                lineTo(4.004f, 10.329f)
                lineTo(3.441f, 10.531f)
                lineTo(2.706f, 10.392f)
                lineTo(2.322f, 9.925f)
                lineTo(2.23f, 9.448f)
                curveTo(2.23f, 9.448f, 2.453f, 9.124f, 2.614f, 9.15f)
                curveTo(2.776f, 9.177f, 3.112f, 9.4f, 3.112f, 9.4f)
                close()
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f
            ) {
                moveTo(3.957f, 6.21f)
                curveTo(3.957f, 6.21f, 3.067f, 6.292f, 2.83f, 6.103f)
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f
            ) {
                moveTo(4.626f, 6.787f)
                curveTo(4.626f, 6.787f, 3.736f, 6.869f, 3.499f, 6.68f)
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f
            ) {
                moveTo(4.775f, 7.316f)
                curveTo(4.775f, 7.316f, 4.295f, 7.397f, 4.248f, 7.23f)
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.625f, 4.75f)
                curveTo(3.694f, 4.75f, 3.75f, 4.694f, 3.75f, 4.625f)
                curveTo(3.75f, 4.556f, 3.694f, 4.5f, 3.625f, 4.5f)
                curveTo(3.556f, 4.5f, 3.5f, 4.556f, 3.5f, 4.625f)
                curveTo(3.5f, 4.694f, 3.556f, 4.75f, 3.625f, 4.75f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun MayottePreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.Mayotte,
            contentDescription = "Mayotte Flag"
        )
    }
}
